import NewWedingModal from './NewWedingModal'
import styles from './NewWedingModal.module.scss'
import ButtonCustom from '../../../components/atoms/button/ButtonCustom'
import Stepper from '../../../components/atoms/Stepper/Stepper'

function Cultural({ open, handleClose, handleNext, handleBack }) {
	return (
		<NewWedingModal
			open={open}
			handleClose={handleClose}
			handleBack={() => handleBack()}
			modalImage="/images/GuestCount.jpg"
		>
			<div
				className={`${styles.welcomeModal} ${styles.guestCount} ${styles.modalMainContainer}`}
			>
				<div className={styles.welcomeModalBody}>
					<h2>
						Are there any cultural significances to your wedding?
					</h2>
					<div
						className=""
						style={{ width: '100%', marginTop: '40px' }}
					>
						<div className={styles.modalContainer}>
							<div className={styles.Budget}>
								<ButtonCustom
									variant="pilled"
									onClick={() => handleNext()}
								>
									Yes
								</ButtonCustom>
								<ButtonCustom
									variant="pilled"
									onClick={() => handleNext()}
								>
									Show me options
								</ButtonCustom>
								<ButtonCustom
									variant="pilled"
									onClick={() => handleNext(2)}
								>
									No
								</ButtonCustom>
							</div>
						</div>
					</div>
				</div>
				<div className={styles.buttonContainer}>
					<Stepper activeStep={2.6} />
				</div>
			</div>
		</NewWedingModal>
	)
}

export default Cultural
